import { useContext, useEffect, useRef } from 'react';

import {
  InsightsContent,
  InsightsContentContext,
} from 'contextProviders/InsightsContentProvider';

// Publishes the content the user is currently viewing to InsightsContentProvider
// so the AI Insights Chat can scope answers to it. Call from a content renderer
// (Dashboard/Report). Pass null to register nothing (e.g. in a popup/wallboard).
// Registration is keyed by entityId; the latest content is read from a ref so a
// changing content object doesn't churn the effect.
const useRegisterInsightsContent = (content: InsightsContent | null): void => {
  const { setCurrent, clearCurrent } = useContext(InsightsContentContext);

  const contentRef = useRef(content);
  contentRef.current = content;

  const entityId = content?.entityId;

  useEffect(() => {
    if (!entityId || !contentRef.current) {
      return undefined;
    }
    setCurrent(contentRef.current);
    return () => clearCurrent(entityId);
  }, [entityId, setCurrent, clearCurrent]);
};

export default useRegisterInsightsContent;
